<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <input
        v-model="email"
        type="email"
        required
        placeholder="email"
      >
      <div class="error">
        {{ error }}
      </div>
      <button>Make Admin</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue'
import makeAdmin from '@/composables/makeAdmin'

export default {
  setup (props, context) {
    const email = ref('')

    // makeAdmin
    const { error, adminEmail } = makeAdmin()

    const handleSubmit = async () => {
      await adminEmail(email.value)
      if (!error.value) {
        context.emit('adminEmail')
      }
    }

    return { email, handleSubmit, error }
  }
}
</script>

<style>

</style>
